import * as React from 'react';

import { PropertyFaq } from '@shared-ui/lodging-property-details';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

interface FaqWrapperProps extends SharedUiWrapperProps {
  isDateless: boolean;
}

const FaqWrapper: React.FC<FaqWrapperProps> = ({ inputs, isDateless }) => {
  if (!isDateless) {
    return null;
  }

  return (
    <UitkSpacing margin={{ block: 'six' }}>
      <div>
        <PropertyFaq inputs={inputs} />
      </div>
    </UitkSpacing>
  );
};

export const SharedUiFaqWrapper = withSharedUiPropertyDetails<FaqWrapperProps>(FaqWrapper);
SharedUiFaqWrapper.displayName = 'SharedUiFaqWrapper';
